<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="reports"
    :sort-by="sortBy"
    :footer-props="footerProps"
    sort-desc
  >
    <template v-slot:item.date="{ item }">
      {{ item.date | dateFormat }}
    </template>
    <template v-slot:item.uploads="{ item }">
      <a
        v-for="upload in item.uploads"
        :key="upload.id"
        class="mx-2"
        target="_blank"
        :href="upload.url"
        style="cursor: pointer; max-width: 500px; float: left; word-wrap: break-word;"
      >
        <v-tooltip
          v-if="
            upload.mime === 'image/jpeg' ||
              upload.mime === 'image/jpg' ||
              upload.mime === 'image/png'
          "
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              {{ upload.original_name }}
            </span>
          </template>
          <v-img :src="upload.url" max-height="1000" max-width="1000"> </v-img>
        </v-tooltip>
        <span v-else>
          {{ upload.original_name }}
        </span>
      </a>
    </template>
    <template v-slot:item.notes="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            class="d-inline-block text-truncate"
            style="max-width: 100px;"
            v-on="on"
          >
            {{ item.notes }}
          </span>
        </template>
        <span style="max-width: 500px; float: left; word-wrap: break-word;">{{
          item.notes
        }}</span>
      </v-tooltip>
    </template>
    <template v-slot:item.expenses="{ item }">
      {{ item.expenses | priceFormat }}
    </template>
    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-list-item @click="$emit('edit', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-pencil</v-icon>
            {{ $t('ITEM.EDIT') }}
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
    <template v-slot:body.append="{ headers }">
      <tr>
        <td class="text-left text-body-1 font-weight-bold" :colspan="1">
          {{ $t('EREPORTER.TOTAL') }}:
        </td>
        <td class="text-right text-body-1 font-weight-bold">
          {{ totalKilometers }} km
        </td>
        <td class="text-right text-body-1 font-weight-bold">
          {{ totalExpenses | priceFormat }} CHF
        </td>
        <td :colspan="headers.length - 5"></td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex';
import { dateFormat, priceFormat } from '@/modules/_global/filters';

export default {
  name: 'PayrollsTaskList',

  filters: {
    dateFormat,
    priceFormat
  },

  props: {
    reports: {
      type: Array,
      default: () => []
    },
    totalKilometers: {
      type: [String, Number],
      default: 0
    },
    totalExpenses: {
      type: [String, Number],
      default: 0
    }
  },

  data: () => ({
    options: {},
    sortBy: 'date',
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    }
  }),

  computed: {
    ...mapState(['loading']),
    headers() {
      return [
        {
          text: this.$t('ITEM.DATE'),
          sortable: true,
          value: 'date'
        },
        {
          text: this.$t('EREPORTER.PAYROLLS.DRIVEN'),
          sortable: true,
          value: 'kilometers',
          align: 'right'
        },
        {
          text: this.$t('EREPORTER.PAYROLLS.EXPENSES'),
          sortable: true,
          value: 'expenses',
          align: 'right'
        },
        {
          text: this.$t('EREPORTER.PAYROLLS.NOTES'),
          sortable: true,
          value: 'notes'
        },
        {
          text: this.$t('ITEM.ATTACHMENTS'),
          sortable: true,
          value: 'uploads'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  }
};
</script>
